export default __webpack_public_path__ + "static/media/logo.c06d6f25.svg";